<template>
    <div class="header h-box is-growx">
        <div class="h-box w-100 space-between">
            <z-logo/>
            <div class="v-box is-growy grow align-right align-auto">
                <h3>ZETO Application deployment</h3>
            </div>
            <div class="v-box">
                <button @click="logout()">
                    Logout
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters([
        ])
    },
    methods: {
        logout () {
            this.$store.dispatch('logout');
        }
    }
};
</script>

<style lang="scss">

@import '../assets/framework';

$header-color: $mine-shaft;
$header-background: $white;
$header-shadow: 1px 1px 5px 3px #ccc;
$header-margin: 10px;
$header-logo-width: 200px;

.header {
    padding: $base-padding;
    color: $header-color;
    background: $header-background;
    box-shadow: $header-shadow;
    width: 100%;
    margin-bottom: $header-margin;

    .h-box > * {
        padding-left: $base-padding;
        $padding-right: $base-padding;
        &:last-child {
            align-self: center;
        }
    }

    .logo {
        width: $header-logo-width;
        margin-right: $header-margin;
        height: auto;
    }

    h3 {
        font-size: 18px;
        font-weight: 600;
        line-height: 24px;
    }

    h5 {
        font-weight: 400;
        font-size: 13px;
        line-height: 24px;
    }
}

</style>
